import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

export default function FullAboutUs() {
  return (
    <section className="relative z-10 px-5 py-10 overflow-hidden md:py-20 ">
      <div className="w-full max-w-xl mx-auto md:max-w-5xl 2xl:max-w-7xl text-brand-main pt-[90px]">
        <div className="flex flex-col justify-center gap-10 lg:gap-24 xl:gap-16 lg:flex-row">
          <div className="relative flex flex-col items-center justify-center md:items-start">
            <div
              data-aos="zoom-in"
              data-aos-delay="200"
              className="relative order-2 w-full mx-auto mb-5 lg:mx-0 rounded-3xl sm:w-fit md:order-none"
            >
              <div className="relative w-full sm:w-[450px] h-[600px]">
                <Image
                  alt="Julie Ann De Armas"
                  fill
                  src="/images/intro.jpg"
                  className="transition-all duration-300 rounded-3xl   object-cover sm:translate-x-[15px]"
                />
              </div>
              <div className="absolute top-1/2 -translate-y-1/2 left-0 w-full h-[90%]  bg-brand-main-lighter -z-10 rounded-3xl" />
            </div>

          </div>

          <div>
            <h1 className="mb-8 text-2xl md:text-4xl payfair text-brand-secondary">Hola, soy Julie Ann De Armas</h1>
            <p className="mb-12 text-base payfair md:text-lg max-w-prose">
              Bienvenido a mi sitio web de psicología y coaching, donde mi misión es ayudarte a
              descubrir y maximizar tu potencial tanto en el ámbito personal como profesional. Mi
              objetivo es transformar tu pasión en un éxito del que puedas estar orgulloso(a). Te
              invito a contactarme y descubrir cómo podemos trabajar juntos para alcanzar tus metas
              y desbloquear tu pleno potencial.
            </p>

            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
              <div>
                <h3 className="mb-2 text-xl text-brand-secondary sm:mb-4 md:text-2xl payfair">
                  Educación y Formación
                  {' '}
                </h3>
                <p className="text-sm payfair md:text-base max-w-prose">
                  Soy Licenciada en Psicología con especialización en Clínica y Recursos Humanos, lo
                  que me proporciona una base sólida para entender las complejidades del
                  comportamiento humano y las dinámicas organizacionales.
                </p>
              </div>
              <div>
                <h3 className="mb-2 text-xl sm:mb-4 text-brand-secondary md:text-2xl payfair">
                  Asesoría Profesional
                  {' '}
                </h3>
                <p className="text-sm payfair md:text-base max-w-prose">
                  Con años de experiencia, ofrezco una perspectiva empática y estratégica, ayudando
                  a mis colaboradores a navegar por desafíos personales y profesionales mediante un
                  enfoque personalizado y basado en la evidencia.
                </p>
              </div>
              <div>
                <h3 className="mb-2 text-xl sm:mb-4 text-brand-secondary md:text-2xl payfair">
                  Certificación en Coaching
                </h3>
                <p className="text-sm payfair md:text-base max-w-prose">
                  Estoy certificada por la ICMF como Coach Profesional, asegurando que recibas apoyo
                  de acuerdo con las mejores prácticas internacionales y los estándares más altos en
                  coaching.
                </p>
              </div>
              <div>
                <h3 className="mb-2 text-xl sm:mb-4 text-brand-secondary md:text-2xl payfair">
                  Becaria de Coaching
                </h3>
                <p className="text-sm payfair md:text-base max-w-prose">
                  He participado en diversos programas de becas que me han permitido refinarme
                  continuamente y estar al día con las últimas tendencias y técnicas en el campo del
                  desarrollo personal y profesional.
                </p>
              </div>
              <div className="col-span-full">
                <Link
                  href="/contacto"
                  className="block px-5 py-3 mt-10 font-semibold text-white transition-all duration-200 payfair w-fit bg-brand-btn hover:bg-brand-btn "
                >
                  Contácteme
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
